const egyptConfig = {
  isZendeskEnabled: true,
  phonePlaceHolder: '01 XXXXXXX',
  currency: 'EGP',
};

export default egyptConfig;